module.exports = __webpack_public_path__ + "static/media/sfv-selector-color.42289acd.png";